import { prop } from 'ramda';
import { isNilOrEmpty } from '../../../../../../server/helpers/index.mjs';

const handleValidationIndicator = (value, rules, hasFieldError, isInvalidValue = false) => {
  const isRequired = prop('required', rules);
  const isValueEmpty = isNilOrEmpty(value);

  if (isRequired) {
    return isValueEmpty || hasFieldError || isInvalidValue;
  }

  return hasFieldError || isInvalidValue;
};

export default handleValidationIndicator;
